import ls from 'local-storage';
import axios from 'axios';
import BaseService from './BaseService';
import { camelizeKeys } from 'humps';
import store from '@/store';


export default {

  isLoggedIn() {
    const user = ls('user');
    return new Promise((resolve, reject) => {
      if (user && user.isAuth) {
        store.dispatch('loggedIn');
        resolve();
      } else {
        store.dispatch('loggedOut');
        reject();
      }
    });
  },

  // Send a request to the login URL and save the returned JWT
  login(creds) {
    let authData = {
      grant_type: 'password',
      type: 'email',
      username: creds.email,
      password: creds.password
    };

    return axios.post(`${process.env.API_URL}/access/token`, authData)
      .then((data) => {
        ls.set('user', {isAuth: true, jwt: data.data});
        store.dispatch('loggedIn');
        this.getUser();
        return Promise.resolve();
      })
      .catch((error) => {
        return Promise.reject();
      });

  },

  refreshTokenRequest: null,

  resetRefreshTokenRequest() {
    this.refreshTokenRequest = null;
  },

  refreshToken() {
    if (!this.refreshTokenRequest) {
      const user = ls.get('user');
      if (_.has(user, 'jwt')) {

        let authData = {
          grant_type: 'refresh_token',
          refresh_token: user.jwt.refresh_token
        };

        this.refreshTokenRequest = axios.post(`${process.env.API_URL}/access/token`, authData);
        this.refreshTokenRequest.then((data) => {
            ls.set('user', {isAuth: true, jwt: data.data});
            store.dispatch('loggedIn');
            this.getUser();
            return Promise.resolve();
          })
          .catch((error) => {
            return Promise.reject();
          });
      }
    }

    return this.refreshTokenRequest;

  },

  getUser() {
    try {
      BaseService.request('get', `user/current`)
        .then((response) => {
          store.dispatch('setUser', camelizeKeys(response.data.data.attributes));
        });
    } catch(e) {

    }
  },

  forgotPassword(email) {
    let requestData = {
      email
    };

    return axios.post(`${process.env.API_URL}/reset-password`, requestData)
      .then(() => {
        return Promise.resolve();
      })
      .catch((error) => {
        return Promise.reject();
      });

  },

  resetPassword(data, token) {
    let requestData = {
      email: data.email,
      token,
      password: data.password,
      passwordConfirmation: data.passwordConfirmation
    };

    return axios.post(`${process.env.API_URL}/complete-reset-password`, requestData)
      .then(() => {
        return Promise.resolve();
      })
      .catch((error) => {
        let errorString = '';
        if (typeof(error.response.data.errors[0].detail) == 'object') {
          errorString = error.response.data.errors[0].detail[0].detail;
        } else {
          errorString = error.response.data.errors[0].detail;
        }
        return Promise.reject(errorString);
      });

  },

  // To log out
  logout: function() {
    ls.remove('user');
    store.dispatch('loggedOut');
    store.dispatch('reset');

    return new Promise((resolve) => resolve());
  }
}